import { getStackedValuesFromDataSeries } from '../../../utilities/getStackedValuesFromDataSeries.js';
import { TOOLTIP_POSITION_DEFAULT_RETURN } from '../constants.js';
import { eventPointNative } from './eventPoint.js';

function getHorizontalBarChartTooltipPosition({
  chartBounds,
  data,
  event,
  eventType,
  index,
  longestSeriesIndex,
  type,
  xScale
}) {
  const groupHeight = chartBounds.height / data[longestSeriesIndex].data.length;
  const isStacked = type === 'stacked';
  if (eventType === 'mouse' && (event instanceof MouseEvent || event instanceof TouchEvent)) {
    const point = eventPointNative(event);
    if (point == null) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    const {
      svgY
    } = point;
    const currentPoint = svgY - 0;
    const currentIndex = Math.floor(currentPoint / groupHeight);
    if (currentIndex < 0 || currentIndex > data[longestSeriesIndex].data.length - 1) {
      return TOOLTIP_POSITION_DEFAULT_RETURN;
    }
    return formatPositionForTooltip(currentIndex);
  } else if (index != null) {
    return formatPositionForTooltip(index);
  }
  return TOOLTIP_POSITION_DEFAULT_RETURN;
  function formatPositionForTooltip(index) {
    var _data$longestSeriesIn, _xScale;
    if (isStacked) {
      const {
        formattedStackedValues
      } = getStackedValuesFromDataSeries(data);
      const x = formattedStackedValues[index].reduce((prev, cur) => {
        const [start, end] = cur;
        if (start < 0) {
          return prev;
        }
        return prev + (xScale(end) - xScale(start));
      }, xScale(0));
      return {
        x: chartBounds.x + x,
        y: chartBounds.y + groupHeight * index,
        activeIndex: index
      };
    }
    const highestValue = (_data$longestSeriesIn = data[longestSeriesIndex].data[index].value) !== null && _data$longestSeriesIn !== void 0 ? _data$longestSeriesIn : 0;
    const x = chartBounds.x + ((_xScale = xScale(highestValue !== null && highestValue !== void 0 ? highestValue : 0)) !== null && _xScale !== void 0 ? _xScale : 0);
    return {
      x: highestValue < 0 ? -x : x,
      y: groupHeight * index,
      activeIndex: index
    };
  }
}

export { getHorizontalBarChartTooltipPosition };
